export default __webpack_public_path__ + "static/media/Left.e3c10822.png";